"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _polished = require("polished");

var _react = _interopRequireDefault(require("react"));

var _useTheme2 = _interopRequireDefault(require("./styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var SeparatorsContainer = function SeparatorsContainer(props) {
  var children = props.children,
      className = props.className,
      style = props.style;

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  var styles = {
    root: {
      '> *': {
        paddingTop: spacing(2),
        paddingBottom: spacing(2)
      },
      '> *:not(:first-child)': {
        borderTop: "1px solid ".concat((0, _polished.transparentize)(0.75, colors.icon))
      }
    }
  };
  return (0, _core.jsx)("div", {
    css: styles.root,
    className: className,
    style: style
  }, children);
};

__signature__(SeparatorsContainer, "useTheme{{ spacing, colors }}", function () {
  return [_useTheme2["default"]];
});

var _default = SeparatorsContainer;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SeparatorsContainer, "SeparatorsContainer", "/builds/bA1zbJom/0/gojob/ui-bits/src/SeparatorsContainer.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/SeparatorsContainer.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();